export default {
  dashboardSubtitle: "取引金額の推移",
  dashboardNotificationSubtitle: "キャンペーン・その他",
  storeSaleData: "加盟店別売上データ",
  franchiseStore: "加盟店"
};
